import { useContext } from 'react';
import { UnicoContext } from './unico-context';

export const useUnico = () => {
  const context = useContext(UnicoContext);
  if (!context) throw new Error('useUnico precisa estar dentro de UnicoProvider');
  return context;
};
